// extracted by mini-css-extract-plugin
export default {"innerTableRow":"LostDamagedPalletsTableItem_innerTableRow__fYAIM"};